export { default as TextAreaController } from './TextArea';
